import { Component, inject, OnInit } from '@angular/core'
import { CommonModule } from '@angular/common'
import { RouterOutlet } from '@angular/router'
import { NzIconModule } from 'ng-zorro-antd/icon'
import { NzLayoutModule } from 'ng-zorro-antd/layout'
import { NzMenuModule } from 'ng-zorro-antd/menu'
import { ru_RU, NzI18nService } from 'ng-zorro-antd/i18n'

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [
        CommonModule,
        RouterOutlet,
        NzIconModule,
        NzLayoutModule,
        NzMenuModule,
    ],
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
    isCollapsed = false
    private i18Service = inject(NzI18nService)

    ngOnInit(): void {
        this.i18Service.setLocale(ru_RU)
    }
}
